if (!customElements.get("w3-image-with-hotspots")) {
  class ImageWithHotspots extends HTMLElement {
    constructor() {
      super();
      this.onHotspotMediaClick = this.onHotspotMediaClick.bind(this);
      this.onAccordionHeaderClick = this.onAccordionHeaderClick.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      // Init variables
      this.hotspotsMedia = this.querySelectorAll(".hotspot--media");
      this.accordionsHeader = this.querySelectorAll(".accordion__header");
      this.accordions = this.querySelectorAll(".accordion");
      this.hotspotsAccordion = this.querySelectorAll(".hotspot--accordion");

      // Check if the elements aren't undefined
      if (!this.hotspotsMedia) return;
      if (!this.accordionsHeader) return;
      if (!this.accordions) return;
      if (!this.hotspotsAccordion) return;

      // Add event listeners
      this.onHotspotMediaClick();
      this.onAccordionHeaderClick();
    }

    onHotspotMediaClick() {
      this.hotspotsMedia.forEach((hotspotMedia, index) => {
        hotspotMedia.addEventListener("click", () =>
          this.handleClick(index, false)
        );
      });
    }

    onAccordionHeaderClick() {
      this.accordionsHeader.forEach((accordionHeader, index) => {
        accordionHeader.addEventListener("click", () =>
          this.handleClick(index, true)
        );
      });
    }

    handleClick(index, isAccordion) {
      // Close others accordions and remove active class on others hotspots
      this.accordions.forEach((accordion, i) => {
        if (i != index) {
          accordion.removeAttribute("open");
          this.hotspotsAccordion[i].classList.remove("hotspot--active");
          this.hotspotsMedia[i].classList.remove("hotspot--active");
        }
      });

      // Toggle correct accordion and active class on correct hotspot
      if (!isAccordion) {
        this.accordions[index].toggleAttribute("open");
      }
      this.hotspotsMedia[index].classList.toggle("hotspot--active");
      this.hotspotsAccordion[index].classList.toggle("hotspot--active");
    }
  }

  customElements.define("w3-image-with-hotspots", ImageWithHotspots);
}
